<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card class="bigbox" elevation="0">
      <v-card-text v-if="Array.isArray(allList) && allList.length > 0">
        <v-treeview
          dense
          selected-color="primary"
          style="border: 1px solid #e8e8e8; border-radius: 4px"
          :items="allList"
          item-disabled="disabled"
        >
          <template v-slot:label="{ item }">
            {{ INT(item[itemText]) }}
          </template>
          <template v-slot:append="{ item }">
            <div class="rowbox">
              <span v-if="$store.state.uuid">
                <span v-if="!item.prompt_name">
                  {{ item.value }}
                </span>
                <mrc_ess_prompt
                  v-if="item.prompt_name"
                  view
                  :chips="false"
                  v-model="item.value"
                  :obj="item.prompt_name"
                >
                </mrc_ess_prompt>
              </span>
              <span v-else>
                <span v-if="!item.prompt_name">
                  {{ item.property_list | getvalue }}
                </span>
                <mrc_ess_prompt
                  v-if="item.prompt_name"
                  view
                  :chips="false"
                  :prompt="getvalueView(item.property_list)"
                  :obj="item.prompt_name"
                >
                </mrc_ess_prompt>
              </span>
              <v-btn icon>
                <v-icon
                  class="material-icons"
                  @click="item.disabled ? '' : addproperty(item)"
                  >{{ !readonly ? "edit" : "visibility" }}</v-icon
                >
              </v-btn>
            </div>
          </template>
        </v-treeview>
        <mrc_ess_myDialog
          :isopen="dialog"
          width="680"
          :title="INT(name)"
          :disabled="!readonly"
          @cancel="close"
          @success="save"
        >
          <v-row>
            <v-col cols="12">
              <mrc_ess_input
                :value="INT(name)"
                :disabled="true"
                label="Property Name"
              ></mrc_ess_input>
            </v-col>
            <v-col cols="12" class="d-flex flex-row-reverse pa-0">
              <!-- <span v-if="!readonly"
                    class="d-flex mr-5"
                    @click="addValue">
                <span style="color:#0F46C1;line-height:34px;font-size:16px">
                  {{ $t('label_new_value_added') }}
                </span>
                <v-btn icon>
                  <v-icon class="material-icons"
                          style="color:#0F46C1;font-size:25px">add</v-icon>
                </v-btn>
              </span> -->
              <mrc_ess_textAddBtn
                :text="$t('label_new_value_added')"
                v-if="!readonly"
                @click="addValue"
              ></mrc_ess_textAddBtn>
            </v-col>
          </v-row>
          <!-- 视图上的新增 -->
          <v-form ref="forms" v-model="valid">
            <v-row v-for="(item, index) in viewList" :key="index + item">
              <v-col cols="5.5">
                <mrc_ess_datePicker
                  :disabled="readonly"
                  :allowedDates="limitedTime"
                  :rules="[(v) => !!v || $t('verify_Required')]"
                  @getTime="getTime"
                  :label="$t('label_effective_start_date')"
                  v-model="item.effective_utc_datetime"
                >
                </mrc_ess_datePicker>
              </v-col>
              <v-col cols="5.5">
                <mrc_ess_input
                  v-model="item.value"
                  v-if="!item.prompt_name"
                  :rules="[(v) => !!v || $t('verify_Required')]"
                  :label="$t('label_value') + '*'"
                >
                </mrc_ess_input>
                <mrc_ess_prompt
                  v-model="item.value"
                  :chips="false"
                  :label="$t('label_value') + '*'"
                  :rules="$t('verify_Required')"
                  v-if="item.prompt_name"
                  :obj="item.prompt_name"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="1" class="d-flex justify-center align-center">
                <v-btn icon>
                  <v-icon
                    @click="deleteItemView(item, index)"
                    class="material-icons"
                    >delete</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>
            <!-- 后端的数据显示 -->
            <v-row v-for="(item, index) in list" :key="index">
              <template
                v-if="
                  item['~type~'] != 'del' &&
                  (readonly ? item.value != '' : true)
                "
              >
                <v-col cols="5.5">
                  <mrc_ess_datePicker
                    :disabled="readonly"
                    :allowedDates="limitedTime"
                    @getTime="getTime"
                    :rules="[(v) => !!v || $t('verify_Required')]"
                    :disabledTwo="
                      item.effective_utc_datetime &&
                      (new Date(item.effective_utc_datetime).valueOf() <
                        compareTimeValue ||
                        new Date(item.effective_utc_datetime).valueOf() <
                          new Date().valueOf())
                    "
                    :label="$t('label_effective_start_date')"
                    v-model="item.effective_utc_datetime"
                  ></mrc_ess_datePicker>
                </v-col>
                <v-col cols="5.5">
                  <mrc_ess_input
                    v-model="item.value"
                    v-if="!item.prompt_name"
                    :readonly="readonly"
                    :rules="[(v) => !!v || $t('verify_Required')]"
                    :disabled="
                      item.effective_utc_datetime &&
                      new Date(item.effective_utc_datetime).valueOf() <
                        compareTimeValue
                    "
                    :label="$t('label_value') + '*'"
                  >
                  </mrc_ess_input>
                  <mrc_ess_prompt
                    v-model="item.value"
                    :chips="false"
                    :disabled="readonly"
                    :disabledTwo="
                      item.effective_utc_datetime &&
                      new Date(item.effective_utc_datetime).valueOf() <
                        compareTimeValue
                    "
                    :label="$t('label_value') + '*'"
                    :rules="$t('verify_Required')"
                    v-if="item.prompt_name"
                    :obj="item.prompt_name"
                  >
                  </mrc_ess_prompt>
                </v-col>
                <v-col
                  cols="1"
                  v-if="!readonly"
                  class="d-flex justify-center align-center"
                >
                  <v-btn
                    icon
                    v-if="
                      !(
                        new Date(item.effective_utc_datetime).valueOf() <
                        compareTimeValue
                      )
                    "
                  >
                    <v-icon
                      @click="deleteItem(item, index)"
                      class="material-icons"
                      >delete</v-icon
                    >
                  </v-btn>
                </v-col>
                <v-col cols="1" v-else class="d-flex justify-center"> </v-col>
              </template>
            </v-row>
          </v-form>
        </mrc_ess_myDialog>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        v-if="!readonly && Array.isArray(allList) && allList.length > 0"
        @cancel="cancel"
        :hideSuccess="Boolean($store.state.uuid)"
        :cancelText="
          !$store.state.uuid
            ? $t('label_The_previous_step')
            : $t('label_cancel')
        "
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  // companyAttrList,
  // companyAttrInfo,
  deleteStaffPropertyGroup,
  // companyAttrUpdate,
  addStaffPropertyGroup,
  getAddList,
} from "@/service/api/staffPropertyGroup.js";
import {
  companyAttrInfo,
  companyAttrUpdate,
  companyAttrList,
} from "@/service/api/company_set";
import {
  getpropertydetail,
  getpropertyupdate,
  getpropertyonedetail,
} from "@/service/api/staffmsg.js";
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
    },
    itemText: {
      type: String,
      default: "company_property_master_name",
    },
  },
  data() {
    return {
      valid: true,
      // rules:,
      skeletonloading: true,
      items: [],
      title: "",
      dialog: false,
      mrbase_sys_staff_property_group: {},
      allList: [], //所有属性
      list: [], //Staff Property Group值属性详情
      viewList: [],
      additems: {
        //新增
        effective_utc_datetime: "", //生效日期
        value: "", //值
      },
      name: "",
      num: 0,
      limitedTime: [], //限制时间
      compareTimeValue: null, //最接近得时间值
      data_type: "",
      prompt_name: "",
      company_property_master_code: "",
      company_property_master_uuid: "",
      isViewInput: false,
      ViewInput: {},
      date: "",
      addUpdateStatus: true, //员工新增还是修改
    };
  },
  created() {},
  async mounted() {
    this.date = Date.parse(new Date());
    if (this.$store.state.uuid) {
      await this.getdetail();
    } else {
      await this.addgetList();
    }
  },
  methods: {
    getTime() {
      this.limitedTime = [];
      [...this.viewList, ...this.list].forEach((item) => {
        if (
          item.effective_utc_datetime == "" ||
          item.effective_utc_datetime == null
        )
          return;
        this.limitedTime.push(item.effective_utc_datetime);
      });
    },
    async addgetList() {
      const res = await getAddList();
      if (res.code == 200) {
        this.addProperty_list(res.data);
        this.allList = res.data;
        this.addDisabled(this.allList, false);
      }
    },
    async getdetail() {
      //获取整个列表
      this.skeletonloading = true;
      try {
        const res = await companyAttrList({
          org_level_uuid: this.$store.state.uuid,
        }); //获取树
        if (res.code == 200) {
          this.allList = res.data.mrbase_sys_staff_property;
          this.addDisabledUpdate(this.allList, false); //加禁用属性

          // this.mrbase_sys_staff_property_group.uuid = res.data.uuid
          // this.mrbase_sys_staff_property_group.staff_property_group_name = this.deleteLanguageCode(
          //   res.data.staff_property_group_name
          // )
          // this.mrbase_sys_staff_property_group.staff_property_group_description = this.deleteLanguageCode(
          //   res.data.staff_property_group_description
          // )
          // this.mrbase_sys_staff_property_group.staff_property_group_code =
          //   res.data.staff_property_group_code
          // this.mrbase_sys_staff_property_group.is_default = res.data.is_default
          // this.mrbase_sys_staff_property_group.org_level_uuid =
          //   res.data.org_level_uuid
          // this.mrbase_sys_staff_property_group.remarks = this.deleteLanguageCode(
          //   res.data.remarks
          // )
        }
        this.skeletonloading = false;
      } catch (err) {
        this.skeletonloading = false;
      }
    },
    getvalueView(val, value = "value") {
      //显示有效的日期
      if (!val) return "";
      if (Array.isArray(val) && val.length <= 0) return "";
      let date = new Date().valueOf();
      let arr = val.filter((item) => {
        return new Date(item.effective_utc_datetime).valueOf() <= date;
      });
      if (Array.isArray(arr) && arr.length <= 0) return "";
      let time = new Date(arr[0].effective_utc_datetime).valueOf();
      let obj = arr[0];
      arr.forEach((item) => {
        if (new Date(item.effective_utc_datetime).valueOf() > time) {
          obj = item;
        }
      });
      return obj[value];
    },
    async addproperty(item) {
      //获取单个行详情
      this.dialog = true;
      this.limitedTime = [];
      this.viewList = [];
      this.list = [];
      if (this.$store.state.uuid) {
        let res = await companyAttrInfo({
          org_level_uuid: this.$store.state.uuid,
          company_property_master_uuid: item.company_property_master_uuid,
        });
        if (res.code == 200) {
          this.name = item.company_property_master_name;
          this.data_type = item.data_type;
          this.prompt_name = item.prompt_name;
          this.company_property_master_code = item.company_property_master_code;
          this.company_property_master_uuid = item.company_property_master_uuid;
          res.data.sort(this.sortBy("effective_utc_datetime"));
          this.compareTimeValue = this.getvalueView(
            res.data,
            "effective_utc_datetime"
          );
          this.list = res.data;
        }
      } else {
        this.data_type = item.data_type;
        this.prompt_name = item.prompt_name;
        this.name = item.company_property_master_name;
        this.company_property_master_code = item.company_property_master_code;
        this.company_property_master_uuid = item.company_property_master_uuid;
        this.list = item.property_list;
      }
      this.getTime();
    },
    addProperty_list(val) {
      val.map((item) => {
        item.property_list = [];
        if (Array.isArray(item.children) && item.children.length > 0) {
          this.addProperty_list(item.children);
        }
      });
    },
    // addDisabled (val, status) { //递归判断状态
    //   if (Array.isArray(val) && val.length > 0) {
    //     val.map(item => {
    //       const isNo = item.property_list.some(item => {
    //         return Date.parse(item.effective_utc_datetime) < this.date
    //       })
    //       this.$set(item, 'disabled', status)
    //       if (Array.isArray(item.children) && item.children.length > 0) {
    //         this.addDisabled(item.children, !isNo)
    //       }
    //     })
    //   }
    // },
    addDisabledUpdate(val, status) {
      //递归判断状态
      if (Array.isArray(val) && val.length > 0) {
        val.map((item) => {
          let isNo = null;
          if (item.value == "") isNo = false;
          else {
            if (item.data_type == "boolean") {
              if (item.value == 1) isNo = true;
              if (item.value == 0) isNo = false;
            } else {
              isNo = true;
            }
          }
          this.$set(item, "disabled", status);
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.addDisabledUpdate(item.children, !isNo);
          }
        });
      }
    },
    sortBy(props) {
      //数组对象排序  降序
      return (a, b) => {
        return new Date(b[props]).valueOf() - new Date(a[props]).valueOf();
      };
    },
    // 首先第一次循环每一项都是可以填得，后面根据父级是否有有效时间且如果为布尔值则更具是否开放
    addDisabled(val, status) {
      //递归判断状态
      if (Array.isArray(val) && val.length > 0) {
        val.map((item) => {
          let isNo = null;
          let arr = item.property_list.filter((item) => {
            //取出小于
            return Date.parse(item.effective_utc_datetime) <= this.date;
          });
          arr.sort(this.sortBy("effective_utc_datetime"));
          if (arr.length <= 0) isNo = false;
          else {
            if (arr[0].data_type == "boolean") {
              if (arr[0].value == 1) isNo = true;
              if (arr[0].value == 0) isNo = false;
            } else {
              isNo = true;
            }
          }
          this.$set(item, "disabled", status);
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.addDisabled(item.children, !isNo);
          }
        });
      }
    },
    itemDisabled(val, status) {
      //递归加状态
      if (Array.isArray(val) && val.length > 0) {
        val.map((item) => {
          item.disabled = status;
          if (item.children > 0) {
            this.itemDisabled(item.children, status);
          }
        });
      }
    },
    success() {
      //获取属性详情 提交
      if (this.$store.state.uuid) {
      } else {
        let arr = this.$clone(this.allList);
        // arr.forEach(item => {
        //   if (item.property_list.length <= 0) {
        //     item.property_list.push({
        //       org_level_uuid: this.$store.state.currentCompany,
        //       company_property_master_code: item.company_property_master_code,
        //       company_property_master_uuid: item.company_property_master_uuid,
        //       value: ''
        //     })
        //   }
        // })
        this.$emit("savesuccess", arr);
      }
    },
    cancel() {
      //上一步
      if (this.$store.state.uuid) {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            // this.$router.go(-1)
            this.$emit("flag", !this.readonly);
          })
          .catch((err) => {});
      }
    },
    deleteItem(item, index) {
      if (item.uuid) {
        this.$set(this.list, index, { ...item, "~type~": "del" });
      } else {
        this.list.splice(index, 1);
      }
    },
    deleteItemView(item, index) {
      const dd = this.viewList.splice(index, 1);
    },
    saveViewList(item) {},
    async save() {
      //提交
      // console.log(this.$refs.forms.validate(), this.valid);
      if (!this.$refs.forms.validate()) return;
      if (this.$store.state.uuid) {
        const mrbase_sys_company_property = this.$deletefield([
          ...this.list,
          ...this.viewList,
        ]);
        const res = await companyAttrUpdate(
          { mrbase_sys_company_property }
          // this.$deletefield(null, { ...mrbase_sys_company_property_group })
        );
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_modification_was_successful"),
          });
          await this.getdetail();
        }
      }
      this.close();
    },
    close() {
      this.dialog = false;
      this.viewList = [];
    },
    updatePropertyList(val, uuid, list) {
      //修改属性List
      val.map((item) => {
        // if (item.company_property_master_code == uuid) {
        //   item.property_list = list
        // }
        if (item.company_property_master_uuid == uuid) {
          item.property_list = list;
        } else {
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.updatePropertyList(item.children, uuid, list);
          }
        }
      });
    },
    addValue() {
      //添加属性
      this.viewList.unshift({
        effective_utc_datetime: "",
        value: "",
        data_type: this.data_type,
        prompt_name: this.prompt_name,
        company_property_master_uuid: this.company_property_master_uuid,
        company_property_master_code: this.company_property_master_code,
        org_level_uuid: this.$store.state.uuid,
      });
    },
    deleteLanguageCode(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          delete item.language_code;
        });
      }
    },
  },
  computed: {},
  watch: {
    group_default_tree: {
      handler(val) {
        // this.items = val
      },
      deep: true,
    },
    staff_property_group_id(v) {
      this.staff_property_group_id = v;
    },
    readonly(v) {
      this.readonly = v;
    },
  },
  filters: {
    getvalue(val) {
      //显示有效的日期
      if (!val) return "";
      if (Array.isArray(val) && val.length <= 0) return "";
      let date = new Date().valueOf();
      let arr = val.filter((item) => {
        return new Date(item.effective_utc_datetime).valueOf() <= date;
      });
      if (arr.length <= 0) return "";
      let time = new Date(arr[0].effective_utc_datetime).valueOf();
      let obj = arr[0];
      arr.forEach((item) => {
        if (new Date(item.effective_utc_datetime).valueOf() > time) {
          obj = item;
        }
      });
      return obj.value;
    },
  },
};
</script>

<style scoped>
.bigbox {
  text-align: left;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rowbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 35vw;
}
/deep/ .v-treeview-node__root {
  border-bottom: 1px solid #e8e8e8;
}
</style>
